import { unstashObject } from 'utils/stash';
import locator from 'utils/locator';
import { REWARDS_PARTNER_KEY } from 'constants/impact';

export const isRewardsPartner = (isInitialRender: boolean) => {
  const urlParams = new URLSearchParams(locator.search);
  const hasRewardsParam = urlParams.get('im_rewards') === '1';

  let hasRewardsStorage = false;
  if (!isInitialRender && !hasRewardsParam) {
    hasRewardsStorage = unstashObject(REWARDS_PARTNER_KEY, { preserve: true }) === '1';
  }

  return hasRewardsParam || hasRewardsStorage;
};
